import { createContext, ReactNode } from 'react';
import { ToastType } from 'src/modules/common/components/Toast/Toast';

export type ToastOptions = {
    type?: ToastType;
    isLowContrast?: boolean;
    title?: ReactNode;
    message: ReactNode;
    duration?: number;
};

export type ToastContextProps = {
    showToast: (options: ToastOptions) => void;
};

export const ToastContext = createContext<ToastContextProps>({
    showToast: () => undefined,
});
